// extracted by mini-css-extract-plugin
module.exports = {"userInfoSkeleton":"userInfoSkeleton_1oa3r","username":"username_2O_o3","__dark":"__dark_1G8sA","light":"light_2bK2T"};